import { FoodsSelect, WhiteBox } from "@foodpilot/foods";
import { Stack, Typography, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { ActionPlanAction } from "src/api/client-api/ActionPlan/ActionPlanAction/useGetOneActionPlanAction";
import {
    ActionPlanActionWrite,
    useUpsertActionPlanAction,
} from "src/api/client-api/ActionPlan/ActionPlanAction/useUpsertActionPlanAction";
import { ACTION_STATUS } from "src/components/Actions/Common/actionStatus";
import { StatusTag } from "src/components/Actions/Common/StatusTag";
import { useActionsContext } from "src/context/Actions/useActionsContext";

type EditStatusProps = {
    actionPlanAction: ActionPlanAction;
};
export const EditStatus = (props: EditStatusProps) => {
    const { actionPlanAction } = props;
    const theme = useTheme();
    const { t } = useTranslation();

    const { actionPlan, savingStatus } = useActionsContext();
    const upsertActionPlanAction = useUpsertActionPlanAction({ actionPlanID: actionPlan?.id });

    const allItems = ACTION_STATUS;

    const existingType = actionPlanAction.type;
    const existingStatus =
        existingType === " " ? allItems[0] : allItems.find((item) => item.backendLabel === existingType);

    return (
        <WhiteBox>
            <Stack padding={theme.spacing(4)}>
                <Stack gap={theme.spacing(2)}>
                    <Typography variant="h5">{t("action-plan.status.title")}</Typography>
                    <Stack flexDirection={"row"} gap={theme.spacing(2)} alignItems={"center"}>
                        <FoodsSelect
                            selectedOption={existingStatus ?? null}
                            options={ACTION_STATUS}
                            onChange={(selectedValue) => {
                                if (selectedValue === null) return;

                                savingStatus.setSaving(true);
                                const newActionPlanAction: ActionPlanActionWrite = {
                                    id: actionPlanAction.id,
                                    type: selectedValue.backendLabel,
                                };
                                upsertActionPlanAction.mutate(newActionPlanAction, {
                                    onSettled: () => {
                                        savingStatus.setSaving(false);
                                    },
                                });
                            }}
                            disabled={savingStatus.isSaving}
                            getId={(item) => item.id}
                            getName={(item) => item.label}
                            textOptions={{
                                placeholder: t("component.select.noResultFound"),
                                searchPlaceholder: "",
                                emptyOptionsText: "",
                                defaultValueText: undefined,
                                noResult: "",
                            }}
                            BoxProps={{
                                maxWidth: "250px",
                            }}
                        />
                        <StatusTag label={existingStatus?.backendLabel} />
                    </Stack>
                </Stack>
            </Stack>
        </WhiteBox>
    );
};
